import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Alert, Card, CardTitle, Text } from '@reveni-io/reveni-ui'

import AppContext from '@/common/context/app.context'

import ByViewTeasers from './ByViewTeasers/ByViewTeasers'
import usePerformanceInsightsNumbers from './hooks/usePerformanceInsightsNumbers/usePerformanceInsightsNumbers'
import PeriodKpis from './PeriodKpis/PeriodKpis'
import YourNumbersCardSkeleton from './YourNumbersCardSkeleton/YourNumbersCardSkeleton'
import * as Styles from './styles'

const YourNumbersCard = ({ periodParams }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const { info } = useContext(AppContext)
  const { numbers, fetchingNumbers, numbersError } = usePerformanceInsightsNumbers({
    storeId: info.selectedStore.id,
    startDate: periodParams.start_date,
    endDate: periodParams.end_date,
  })

  if (fetchingNumbers) return <YourNumbersCardSkeleton />

  if (numbersError) {
    return (
      <Card>
        <CardTitle marginBottom={theme.spacing.sp16}>{t('Tus números')}</CardTitle>
        <Alert type="error">{t('No se han podido cargar los datos. Inténtalo de nuevo.')}</Alert>
      </Card>
    )
  }

  return (
    <Card>
      <CardTitle marginBottom={theme.spacing.sp16}>{t('Tus números')}</CardTitle>
      <Styles.Content>
        <PeriodKpis numbers={numbers} />
        <Text type="allCapsM" color={theme.colors.text.subtle}>
          {t('Por vista')}
        </Text>
        <ByViewTeasers numbers={numbers} />
      </Styles.Content>
    </Card>
  )
}

export default YourNumbersCard
